var _style, _ellipse, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhysioFitnessDisable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#40485f;stroke-miterlimit:10;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 39.46,
    cy: 10.54,
    rx: 4.72,
    ry: 4.67
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.84,13.07l-6.29,6.22c0,0-1.54,1.61-3.41,0c-0.4-0.74-1.14-1.94,0.6-3.55c1.74-1.61,7.36-7.29,7.36-7.29 s1.67-1.81,3.55,0s5.62,5.62,5.62,5.62s1.54,1.2,0.67,2.88c-0.54,0.6-2.34,1.81-3.88,0.27C27.51,15.68,24.84,13.07,24.84,13.07z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.61,19.42v3.48h7.16c0,0,2.34,0.4,2.14,2.14c-0.07,0.27,0.4,1.61-2.01,2.01c-2.41-0.07-9.84-0.07-9.84-0.07 s-1.47,0-1.41-1.87s0.13-2.07,0.13-2.07L34.61,19.42z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.42,31.6L9.78,43.38c0,0-1.74,1.47-3.35-0.13c-0.54-0.87-1.07-2.01,0.8-3.81s10.84-10.84,10.84-10.84 L21.42,31.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.24,24.98l7.29,7.23c0,0,2.07,2.21-0.27,4.08c-2.88,1.67-9.24,5.15-9.24,5.15s-2.34,1-3.35-1.07 c-0.13-0.67-0.74-2.07,1.34-3.28c2.07-1.2,6.36-3.35,6.36-3.35l-5.96-5.96c0,0-0.74-2.01,0.2-3.15 C22.29,24.04,23.63,23.31,25.24,24.98z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysioFitnessDisable);
export default __webpack_public_path__ + "static/media/physio-fitness-disable.820fdac2eb3391645d9a4e067f223d69.svg";
export { ForwardRef as ReactComponent };